import React, { useEffect } from 'react';
import '../assets/styles/styles.css';
import bonez_logo from '../assets/images/512x512.png';
import { socket, socketConnected } from "./../utils/nakama";
import opCodes from './../constants/opCodes.jsx';
import { isSpectator, leaveGameSpectator, matchIdGame} from '../pages/game/Game';
import { playSound, handleClickSound } from "../pages/game/scenes/classes/PlaySound";

function LeaveGameModal(props) {
  const handleForfeit = async () => {
    // Close the modal
    props.onCloseModal();

    if (!isSpectator) {
      try {
        await socket.sendMatchState(matchIdGame.toString(), parseInt(opCodes.playerForfeit), null);
        console.log("Forfeit requested", leaveGameSpectator.value, matchIdGame);
       
      } catch (err) {
        console.log("Error forfeiting: ", err);
      }
    } else {
      leaveGameSpectator.value = true;
      console.log("leaveGameSpectator.value:", leaveGameSpectator.value, matchIdGame);
    }

    // resetGame();
  };

  // const resetGame = () => {
  //   if (props.gameRef.current) {
  //     props.gameRef.current.destroy(true);
  //     props.gameRef.current = null;
  //   }
  // };

  return (
    <div className="d-flex justify-content-center row">
      <div className="whole-container forfeit" style={{ width: "200%" }}>
        <img src={bonez_logo} className="forfeit-logo" style={{ width: "20%", height: "20%", marginTop: "-15%", marginLeft: "0%" }} alt="" />
        <div>
          {!isSpectator ? (
          <h1 className="page-title pink-text" style={{ marginLeft: "5%", marginRight: "5%" }}>Forfeit game & lose your wager?</h1>
        ) : (
          <h1 className="page-title pink-text" style={{ marginLeft: "5%", marginRight: "5%" }}>Want to Leave Spectator view?</h1>
        )}
        </div>
        <button onClick={(e) => {
            handleForfeit();
            playSound("clickSound");
          }}
          className="button forfeit-game-button"
          style={{marginRight:"15%"}}
        >
          <audio id="clickSound" class="sound-fx" hidden>
            <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
            Your browser does not support the audio element.
          </audio>
          <img src="https://zoombies.world/images/dapp/red_button_400.webp" alt="" style={{ width: "100%", height: "100%" }} />
          
          {!isSpectator ? (
            <span className="button-text" style={{ color: "white", marginLeft: '-1%' }}>Forfeit</span>
          ) : (
            <span className="button-text" style={{ color: 'white', marginLeft: '-1%'}}>Leave</span>
          )}
        </button>

        <button onClick={(e) => {
            props.onCloseModal();
            playSound("clickSound");
          }}
          className="button forfeit-game-button"
        >
          <audio id="clickSound" class="sound-fx" hidden>
            <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
            Your browser does not support the audio element.
          </audio>
          <img src="https://zoombies.world/images/dapp/green_button_400.webp" alt="" style={{ width: "100%", height: "100%" }} />
          <span className="button-text return" style={{ color: "#000000", marginLeft: '1%' }}>Return to Game</span>
        </button>
      </div>
    </div>
  );
}

export default LeaveGameModal;
